export const formatError = (e, message) => ({
  error: true,
  errors: [((e.response || {}).data || {}).error || message],
})
